// eslint-disable-next-line import/no-amd
define([
    '../../../utils/Globals',
    'jquery',
    'underscore',
    '../../app/models/MabinsoModel'
], (Globals, $, _, MabinsoModel) => {
    const Model = MabinsoModel.extend({
        urlRoot: Globals.baseUrl + 'interfaces/config',
        defaults: {
        },
        initialize() {
        },
        isType(value) {
            if (this.get('type') === value) return true;
            return false;
        },
        getLabel() {
            const mylabel = Globals.i18n.data['form.' + this.get('name')];
            if (mylabel !== undefined && mylabel !== false && mylabel !== null) {
                return mylabel;
            }
            return this.get('label');
        },
        isIntern() {
            const onExec = this.get('onExec');
            if (onExec) {
                if (this.get('name').indexOf('intern') === -1 && this.get('name').indexOf('on_exec') !== -1) {
                    return false;
                }
            } else if (this.get('name').indexOf('intern') === -1 && this.get('name').indexOf('on_exec') === -1) {
                return false;
            }

            return true;
        }
    });
    return Model;
});



// WEBPACK FOOTER //
// ./src/components/interface/models/InterfaceParameterModel.js